"use strict";
/** state: Final **/
/** family: NavBar **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var icon_types_1 = require("../../types/icon.types");
var Badge_1 = require("../Badge");
var FontAwesome_1 = require("../FontAwesome");
var IconWrapper_1 = require("../IconWrapper");
var CLASS_NAME = 'i-nav-item';
var NavLayout;
(function (NavLayout) {
    NavLayout["Horizontal"] = "horizontal";
    NavLayout["Vertical"] = "vertical";
})(NavLayout = exports.NavLayout || (exports.NavLayout = {}));
var iconContent = function (props) {
    // Following logic is to decide which font awesome icon we are gonna show.
    // i.e the loading icon or the desktop icon or the mobile icon based on various conditions
    var mobileIconName = props.isMobile && props.mobileIconName;
    var loadingIconName = props.showLoading && !props.iconLoader && icon_types_1.Icon.Loading;
    var iconName = loadingIconName || mobileIconName || props.iconName || null;
    // Creating a Fontawesome element with the above icon name if icon name is present.
    var fontAwesomeIcon = iconName && (React.createElement(FontAwesome_1.FontAwesome, { name: iconName, spin: props.showLoading, size: FontAwesome_1.FontAwesome.Size.Large }));
    // Decide on which icon to show - the loading icon created above or an icon passed in props.
    var mobileIcon = props.isMobile && props.mobileIcon;
    var loadingIcon = props.showLoading && props.iconLoader;
    var icon = loadingIcon || fontAwesomeIcon || mobileIcon || props.icon;
    return icon ? React.createElement(IconWrapper_1.IconWrapper, null, icon) : null;
};
var NavItemContent = (function (_a) {
    var badge = _a.badge, icon = _a.icon, iconLoader = _a.iconLoader, iconName = _a.iconName, isMobile = _a.isMobile, label = _a.label, labelHidden = _a.labelHidden, layout = _a.layout, mobileIconName = _a.mobileIconName, mobileIcon = _a.mobileIcon, showLoading = _a.showLoading;
    return (React.createElement("div", { className: classNames(CLASS_NAME + "__content", {
            vertical: layout === NavLayout.Vertical,
        }) },
        iconContent({
            icon: icon,
            iconLoader: iconLoader,
            iconName: iconName,
            isMobile: isMobile,
            mobileIcon: mobileIcon,
            mobileIconName: mobileIconName,
            showLoading: showLoading,
        }),
        !labelHidden &&
            (!isMobile ||
                (!icon && !mobileIcon && !mobileIconName && !iconName)) && (React.createElement("span", { className: CLASS_NAME + "__title", "aria-hidden": true }, label)),
        badge && (React.createElement(Badge_1.Badge, __assign({}, badge, { className: classNames(badge.className, {
                'badge--default': badge.color === undefined,
            }), color: badge.color || null })))));
});
exports.NavItemContent = NavItemContent;
NavItemContent.Layout = NavLayout;
NavItemContent.defaultProps = {
    layout: NavLayout.Horizontal,
};
//# sourceMappingURL=NavItemContent.js.map